/**
 * OFFER BASKET
 *
 * Deliberately NOT persisted server-side. The basket lives in sessionStorage:
 * it survives navigating grid -> product -> grid within a tab, and disappears
 * when the tab closes. That matches the app's behaviour - a temporary screen
 * for assembling a multi-item offer, with nothing reserved and no lifecycle to
 * manage before submission.
 *
 * On submit the whole basket goes to the backend in one request and becomes a
 * single multi-item offer.
 */
(function () {
  var KEY = '3ft_offer_basket';
  var ENDPOINT = '/apps/einstein/storefront-offers';
  var MAX_ITEMS = 20;

  // --- storage -------------------------------------------------------------

  function read() {
    try {
      var raw = sessionStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {
      console.error('[offer-basket] could not save basket', e);
    }
    updateBadges();
  }

  function clear() {
    try {
      sessionStorage.removeItem(KEY);
    } catch (e) {}
    updateBadges();
  }

  function has(variantId) {
    return read().some(function (i) {
      return String(i.variant_id) === String(variantId);
    });
  }

  // --- badge / button state ------------------------------------------------

  function updateBadges() {
    var count = read().length;

    document.querySelectorAll('[data-offer-basket-count]').forEach(function (el) {
      el.textContent = count ? String(count) : '';
      el.hidden = count === 0;
    });

    document.querySelectorAll('[data-offer-add]').forEach(function (btn) {
      var inBasket = has(btn.getAttribute('data-variant-id'));
      btn.classList.toggle('is-added', inBasket);
      btn.textContent = inBasket ? 'Added' : 'Offer';
    });

    document.querySelectorAll('[data-offer-basket-link]').forEach(function (el) {
      el.hidden = count === 0;
    });
  }

  // --- adding from a card --------------------------------------------------

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-offer-add]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var items = read();

    // Tapping again removes it - the button doubles as a toggle.
    if (has(variantId)) {
      write(
        items.filter(function (i) {
          return String(i.variant_id) !== String(variantId);
        })
      );
      return;
    }

    if (items.length >= MAX_ITEMS) {
      alert('You can offer on up to ' + MAX_ITEMS + ' tapes at once.');
      return;
    }

    items.push({
      variant_id: variantId,
      product_id: btn.getAttribute('data-product-id') || '',
      title: btn.getAttribute('data-product-title') || '',
      url: btn.getAttribute('data-product-url') || '',
      image: btn.getAttribute('data-product-image') || '',
      list_price_cents: parseInt(btn.getAttribute('data-listed-price'), 10) || 0,
      amount_cents: null,
      price_match_link: '',
    });
    write(items);
  });

  // --- basket page ---------------------------------------------------------

  var page = document.querySelector('[data-offer-basket-page]');

  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return '';
    return '$' + (n / 100).toFixed(2);
  }

  function renderBasket() {
    if (!page) return;

    var listEl = page.querySelector('[data-offer-basket-list]');
    var emptyEl = page.querySelector('[data-offer-basket-empty]');
    var footerEl = page.querySelector('[data-offer-basket-footer]');
    var items = read();

    listEl.innerHTML = '';

    if (!items.length) {
      emptyEl.hidden = false;
      listEl.hidden = true;
      if (footerEl) footerEl.hidden = true;
      return;
    }

    emptyEl.hidden = true;
    listEl.hidden = false;
    if (footerEl) footerEl.hidden = false;

    items.forEach(function (item, index) {
      var li = document.createElement('li');
      li.className = 'offer-basket__item';

      var link = document.createElement('a');
      link.className = 'offer-basket__link';
      link.href = item.url || '#';

      if (item.image) {
        var img = document.createElement('img');
        img.className = 'offer-basket__image';
        img.src = item.image;
        img.alt = item.title || '';
        img.loading = 'lazy';
        link.appendChild(img);
      }

      var details = document.createElement('div');
      details.className = 'offer-basket__details';

      var title = document.createElement('span');
      title.className = 'offer-basket__title';
      title.textContent = item.title || 'Untitled';
      details.appendChild(title);

      var listed = document.createElement('span');
      listed.className = 'offer-basket__listed';
      listed.textContent = 'List: ' + money(item.list_price_cents);
      details.appendChild(listed);

      link.appendChild(details);
      li.appendChild(link);

      var controls = document.createElement('div');
      controls.className = 'offer-basket__controls';

      var amountWrap = document.createElement('div');
      amountWrap.className = 'offer-modal__input-row';

      var currency = document.createElement('span');
      currency.className = 'offer-modal__currency';
      currency.textContent = '$';
      amountWrap.appendChild(currency);

      var amount = document.createElement('input');
      amount.type = 'number';
      amount.className = 'offer-modal__input';
      amount.min = '1';
      amount.step = '0.01';
      amount.inputMode = 'decimal';
      amount.placeholder = '0.00';
      amount.setAttribute('aria-label', 'Your offer for ' + (item.title || 'this tape'));
      if (item.amount_cents) amount.value = (item.amount_cents / 100).toFixed(2);
      amount.addEventListener('input', function () {
        var current = read();
        var dollars = parseFloat(amount.value);
        current[index].amount_cents = isFinite(dollars) ? Math.round(dollars * 100) : null;
        // Write without re-rendering, or the field loses focus mid-typing.
        try {
          sessionStorage.setItem(KEY, JSON.stringify(current));
        } catch (e) {}
        updateTotal();
      });
      amountWrap.appendChild(amount);
      controls.appendChild(amountWrap);

      var linkLabel = document.createElement('label');
      linkLabel.className = 'offer-basket__link-label';
      linkLabel.textContent = 'Link to a lower price you found? (optional)';
      controls.appendChild(linkLabel);

      var priceLink = document.createElement('input');
      priceLink.type = 'url';
      priceLink.className = 'offer-modal__input offer-modal__input--text';
      priceLink.placeholder = 'https://...';
      priceLink.value = item.price_match_link || '';
      priceLink.addEventListener('input', function () {
        var current = read();
        current[index].price_match_link = priceLink.value.trim();
        try {
          sessionStorage.setItem(KEY, JSON.stringify(current));
        } catch (e) {}
      });
      controls.appendChild(priceLink);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'offer-basket__remove';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () {
        var current = read();
        current.splice(index, 1);
        write(current);
        renderBasket();
      });
      controls.appendChild(remove);

      li.appendChild(controls);
      listEl.appendChild(li);
    });

    updateTotal();
  }

  function updateTotal() {
    if (!page) return;
    var totalEl = page.querySelector('[data-offer-basket-total]');
    if (!totalEl) return;
    var total = read().reduce(function (sum, i) {
      return sum + (i.amount_cents || 0);
    }, 0);
    totalEl.textContent = money(total);
  }

  // --- submit --------------------------------------------------------------

  if (page) {
    var submitBtn = page.querySelector('[data-offer-basket-submit]');
    var errorEl = page.querySelector('[data-offer-basket-error]');
    var messageEl = page.querySelector('[data-offer-basket-message]');
    var counterEl = page.querySelector('[data-offer-basket-counter]');

    function showError(text) {
      if (!errorEl) return;
      errorEl.textContent = text;
      errorEl.hidden = false;
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (errorEl) errorEl.hidden = true;

        var items = read();
        if (!items.length) {
          showError('Your offer list is empty.');
          return;
        }

        for (var i = 0; i < items.length; i += 1) {
          if (!items[i].amount_cents || items[i].amount_cents <= 0) {
            showError('Enter an offer amount for every tape.');
            return;
          }
          if (
            items[i].list_price_cents &&
            items[i].amount_cents >= items[i].list_price_cents
          ) {
            showError(
              'Your offer on "' + items[i].title + '" must be less than the listed price.'
            );
            return;
          }
        }

        submitBtn.disabled = true;
        submitBtn.textContent = 'Setting up\u2026';

        fetch(ENDPOINT, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: items.map(function (i) {
              return {
                variant_id: i.variant_id,
                amount_cents: i.amount_cents,
                price_match_link: i.price_match_link || '',
              };
            }),
            message: messageEl ? messageEl.value.trim() : '',
            open_to_counter: counterEl ? counterEl.checked : true,
          }),
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.error || 'Could not create the offer.');
              return data;
            });
          })
          .then(function (data) {
            if (!data.checkout_url) throw new Error('No checkout URL returned.');
            // Basket is submitted - clear it so returning to the site is clean.
            clear();
            window.location.href = data.checkout_url;
          })
          .catch(function (err) {
            console.error('[offer-basket] submit failed', err);
            showError(err.message || 'Something went wrong. Please try again.');
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit offer';
          });
      });
    }

    renderBasket();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBadges);
  } else {
    updateBadges();
  }
})();
